module.exports = __webpack_public_path__ + "static/media/toggle_comfortable_Unselected.c6aaeb1b.svg";